<template>
    <span>
        <v-tooltip v-if="toolTip" bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn 
                    :class="classStyle" 
                    :to="to" 
                    :target="target" 
                    :disabled="disabled" 
                    :loading="loading" 
                    v-bind="attrs" 
                    v-on="on" 
                    icon
                    :aria-label="ariaLabel || toolTip"
                >
                    <span>
                        <v-icon 
                            :small="small || (!cancelAutoSmall && $vuetify.breakpoint.name != 'xs')" 
                            :color="color" 
                            @click.prevent.stop="$emit('click')"
                            aria-hidden="true"
                        >{{ icon }}</v-icon>
                        <small v-if="textButton"><br/>{{ textButton }}</small>
                    </span>
                    
                </v-btn>
            </template>
            <span>{{ toolTip }}</span>
        </v-tooltip>
        <v-btn 
            :class="classStyle" 
            :to="to" 
            :target="target" 
            v-else 
            :disabled="disabled" 
            :loading="loading" 
            icon
            :aria-label="ariaLabel || 'Ação'"
        >
            <span>
                <v-icon 
                    :small="small || (!cancelAutoSmall && $vuetify.breakpoint.name != 'xs')" 
                    :color="color" 
                    @click.prevent.stop="$emit('click')"
                    aria-hidden="true"
                >{{ icon }}</v-icon>
                <small v-if="textButton"><br/>{{ textButton }}</small>
            </span>
            
        </v-btn>
    </span>
    
</template>
<script>
export default {
    name: "EmcTableIcon",
    data () {
        return {
            
        }
    },
    props: {
        color: {
            type: String,
            default: "blue accent-4"
        },
        icon: {
            type: String,
            required: true
        },
        toolTip: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        cancelAutoSmall: {
            type: Boolean,
            default: false
        },
        to: {
            default: null
        },
        target: {
            default: null
        },
        textButton: {
            type: String,
            default: null
        },
        classStyle: {

        },
        /**
         * Rótulo acessível para leitores de tela
         * Se não informado, usa o toolTip como fallback
         */
        ariaLabel: {
            type: String,
            default: null
        }
    },
}
</script>
